import { AdvancedPaymentTaxModel } from "./advancedPaymentTax.model";
import { AdvancedPaymentLineModel } from "./advancedPaymentline.model";

export class AdvancePaymentModel {

    uid: string;
    invoiceUid: string;
    providerUid: string;
    providerName: string;
    date: Date;
    taxes: Array<AdvancedPaymentTaxModel>;
    advancedPaymentLines: Array<AdvancedPaymentLineModel>;
    concept: string;
    base: number;
    total: number;
    expenseNumber: string;
    isInvoice: boolean;
    activityUid: string;
    activityName: string;
    fiscalYear: number;
    typePay: string;
    typePayBankAccount : string;
    efectivoId: string;
    partnersId: number;
    
    constructor() {
        this.taxes = new Array<AdvancedPaymentTaxModel>();
    }
}
